module.exports = __webpack_public_path__ + "img/seed-analyzer-logo.346604c6.svg";